// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"698":"124b309f","880":"124b309f"}[chunkId] + ".css";
};